import { createFileRoute, redirect } from '@tanstack/react-router'
import AgenteEditPage from '@/pages/dashboard/agente-edit-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/agentes/$agenteId',
)({
  beforeLoad: ({ params }) => {
    // Se o agenteId for "novo", redireciona para a rota correta
    if (params.agenteId === 'novo') {
      throw redirect({
        to: '/dashboard/$dashboardId/sistema/agentes/novo',
        params: { dashboardId: params.dashboardId },
        search: {},
      })
    }
  },
  component: function AgenteEditRoute() {
    const { dashboardId, agenteId } = Route.useParams()
    return (
      <RequireModule module={MODULES.IA_AGENTES} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <AgenteEditPage dashboardId={dashboardId} agenteId={agenteId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
